import type { QuanHuyen, TinhThanh, XaPhuong } from '@/types/schemas';
import type { DataTableColumn } from '@/components/custom/erp';

export type WardTableRow = XaPhuong & {
  id: string;
  provinceCode?: string;
  provinceName?: string;
  districtCode?: string;
  districtName?: string;
};

export const getDataTableColumns = (): DataTableColumn<WardTableRow>[] => [
  {
    field: 'ma_xp',
    headerName: 'Mã xã/phường',
    width: 200
  },
  {
    field: 'ten_xp',
    headerName: 'Tên xã/phường',
    width: 320
  },
  {
    field: 'ten_xp2',
    headerName: 'Tên khác',
    width: 320
  },
  {
    field: 'provinceCode',
    headerName: 'Mã tỉnh/thành',
    width: 200
  },
  {
    field: 'provinceName',
    headerName: 'Tên tỉnh/thành',
    width: 320
  },
  {
    field: 'districtCode',
    headerName: 'Mã huyện/quận',
    width: 200
  },
  {
    field: 'districtName',
    headerName: 'Tên huyện/quận',
    width: 320
  }
];

export const provinceColumns: DataTableColumn<TinhThanh>[] = [
  {
    field: 'ma_tinh',
    headerName: 'Mã tỉnh/thành',
    width: 200
  },
  {
    field: 'ten_tinh',
    headerName: 'Tên tỉnh/thành',
    width: 320
  }
];

export const districtColumns: DataTableColumn<QuanHuyen>[] = [
  {
    field: 'ma_quan',
    headerName: 'Mã quận/huyện',
    width: 200
  },
  {
    field: 'ten_quan',
    headerName: 'Tên quận/huyện',
    width: 320
  }
];
